import React from 'react'

export default function SecondarySelect({options,value,setValue,error,placeholder,viewMode,customLabel=false,customValue=false}) {
    return (
        <div className="relative pb-3 md:pb-5">
        <select className={error ? 'error-input' : 'px-2 pr-0'} value={value ? value :''} disabled={viewMode} onChange={(e)=>setValue(e.target.value)} required={true}>
                    <option value={''} >{placeholder}</option>
                    {
                        options.map((item,index)=>
                        {
                            return <option key={index} value={customValue ? item[customValue] : item.id}>{customLabel ? item[customLabel] : item.name}</option>
                        })
                    }
                </select>
                {error ? <div className="w-full absolute left-0 bottom-0 flex items-center pointer-events-none overflow-hidden h-4">
                                <div className='text-center'>
                            <p className='text-red-600 h-[20px] text-[12px] tracking-tight font-medium whitespace-nowrap'>{error}</p>
                                    </div>
                        </div> : null}
                </div>
  )
}
